export default function CircularProgress({ value = 0, size = 160, stroke = 12, color = "#EF4444", label, sublabel }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (value / 100) * c;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={r} stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} fill="none"/>
        <circle
          cx={size/2} cy={size/2} r={r}
          stroke={color} strokeWidth={stroke} fill="none"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 700ms ease", filter: `drop-shadow(0 0 8px ${color}88)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-3xl font-bold" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>{value}%</div>
        {label && <div className="text-[10px] uppercase tracking-widest text-zinc-400 mt-0.5">{label}</div>}
        {sublabel && <div className="text-[10px] text-zinc-500 mt-0.5">{sublabel}</div>}
      </div>
    </div>
  );
}
